import React from 'react';

import { Divider, Link, Surface, TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './NgzNutritionAccountNotFound.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import WarningImage from '../../../../../assets/images/vectors/warning-rounded.svg';
import { NutritionRegistrationBlock } from '../../components/NutritionRegistrationBlock/NutritionRegistrationBlock';
import { ContactCard } from '../../../shared/components/ContactCard/ContactCard';
import { useEntityData } from './hooks/useEntityData';
import { getFlagsObject } from '../../../shared/utils/sortingAndGroupingUtil';
import { BILLING_TYPE } from '../../../shared/constants/user-info/billingType';

const NgzNutritionAccountNotFound = () => {
  const { entityData } = useEntityData();

  if (!entityData) {
    return null;
  }

  const billingTypeFlags = getFlagsObject(BILLING_TYPE, [entityData.billingType]);

  const { entityName, adminEmail, adminPhone, adminAvatar, customerRegistrationLink } =
    entityData;

  return (
    <div className={classes.container}>
      <Surface className={classes.paper}>
        <div className={classes.titleSection}>
          <img src={WarningImage} alt="warning" />
          <TitleWithDescription
            title="Nutrition Account is not Found"
            description="To join the challenge, please create your nutrition account first. When your SWYMO subscription is 'Active,' you will be able to join the challenge."
            titleFont="title-18-bold"
          />
        </div>
        <NutritionRegistrationBlock nutritionRegistrationUrl={customerRegistrationLink} />
        {billingTypeFlags.SELF_BILLING && (
          <div className={classes.section}>
            <Divider />
            <TitleWithDescription
              title="Contact to Create Your Nutrition Subscription"
              titleFont="title-18-bold"
              description="Before creating an account, please contact us to discuss the terms of cooperation."
            />
            <ContactCard
              title="Contact"
              name={entityName}
              email={adminEmail}
              phone={adminPhone}
              avatar={adminAvatar}
            />
          </div>
        )}
        {billingTypeFlags.AUTOMATED_BILLING && (
          <p className={classes.footerText}>
            <span className={classes.bold}>Need help?</span> Please contact our team
            at&nbsp;
            <Link href={`mailto:${adminEmail}`}>{adminEmail}</Link> for assistance.
          </p>
        )}
      </Surface>
    </div>
  );
};

angularizeWithProviders(NgzNutritionAccountNotFound, 'ngzNutritionAccountNotFound', {});
